const walletAdv = {
  path: '/adManage/walletAdv',
  name: 'adManage/walletAdv',
  component: resolve => require(['../../views/adManage/walletAdv.vue'], resolve),
  meta: { title: '广告管理',keepActive:true }
};
export default [walletAdv];



// WEBPACK FOOTER //
// ./src/router/modules/adManage.js